var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65 65",
    width: 65,
    height: 65,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 0h-26A6.51 6.51 0 0 0 13 6.5v52a6.51 6.51 0 0 0 6.5 6.5h26a6.51 6.51 0 0 0 6.5-6.5v-52A6.51 6.51 0 0 0 45.5 0zm3.9 58.5c0 2.15-1.75 3.9-3.9 3.9h-26c-2.15 0-3.9-1.75-3.9-3.9v-52c0-2.15 1.75-3.9 3.9-3.9h26c2.15 0 3.9 1.75 3.9 3.9v52zM35.102 5.2h-5.2a1.3 1.3 0 1 0 0 2.6h5.2a1.3 1.3 0 1 0 0-2.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 57.2a1.3 1.3 0 0 0 0 2.6 1.3 1.3 0 0 0 0-2.6zm18.2-46.8H14.3a1.3 1.3 0 0 0 0 2.6h36.4a1.3 1.3 0 1 0 0-2.6zm0 41.6H14.3a1.3 1.3 0 1 0 0 2.6h36.4a1.3 1.3 0 1 0 0-2.6z"
  })));
}

export default __webpack_public_path__ + "media/8dd65318.svg";
export { SvgIphone as ReactComponent };